import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Optional, QueryList, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Loading, TemplateDirective } from '@fleet-beat/core';
import { Subscription, timer } from 'rxjs';
import { SimpleField } from '../../abstracts';
import { AnexConfig } from '../../models';

@Component({
  selector: 'fb-password-field',
  templateUrl: './password-field.component.html',
  styleUrls: ['./password-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordFieldComponent extends SimpleField<string> {
  @Input() minLength: number;
  @Input() maxLength: number;
  @Input() prefix: AnexConfig;
  @Input() suffix: AnexConfig;
  @Input() passwordRequirements: boolean;
  @Input() loading: Loading = new Loading();
  @Input() templates: QueryList<TemplateDirective<object>>;
  @Input() noLabel: boolean;

  isPasswordVisible: boolean = false;

  private timerSubscription: Subscription = new Subscription();

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Self()
    public override ngControl: NgControl,
  ) {
    super(changeDetectorRef, ngControl);
  }

  toggleShowPassword(): void {
    this.isPasswordVisible = !this.isPasswordVisible;

    this.timerSubscription.unsubscribe();
    this.timerSubscription = new Subscription();

    if (this.isPasswordVisible) {
      this.timerSubscription.add(
        timer(5000).subscribe(() => {
          this.isPasswordVisible = false;
          this.changeDetectorRef.markForCheck();
        }),
      );
    }
  }
}
